// let _events = ['boarded', 'fire', 'ship', 'nothing', 'hull-breach', 'bomb']

export enum EVoyageWaveType {
  Default = -1,
  Null = 0,
  BoardedByAliens = 1,
  Fire = 2,
  HullBreach = 3,
  Bomb = 4,
  AlienShip = 5,
}

export interface IVoyageMissionWave {
  type: EVoyageWaveType
  amount: number
  magnitude: number
  postWaveTime: number
  waitTillClear: boolean
}

const _default: IVoyageMissionWave = {
  amount: 1,
  magnitude: 1,
  postWaveTime: 2,
  waitTillClear: true,
  type: EVoyageWaveType.Null,
}

export function create(
  type: EVoyageWaveType,
  args: Partial<IVoyageMissionWave>,
) {
  return Object.assign({}, _default, args, { type })
}
